import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex/state'
// 中转组件
import transfer from '@/components/common/transfer'
import config from '@/conf'
import axios from 'axios';

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/productindex',
      name: 'productindex',
      component: resolve => require(['@/components/product/product_index'], resolve),
      meta: {
        title: `${config.shopnamechina}` + '定制商城'
      }
    },
    //路由重定向
    {
      path:'/',
      redirect:'/productindex'
    },
    {
      path: '/search',
      name: 'search',
      component: resolve => require(['@/components/index_children/search'], resolve),
      meta: {
        title: '个人中心'
      }
    },
    // 中转路由
    {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
      replace: true
    },
    {
      path: '/person_center',
      name: 'person_center',
      component: resolve => require(['@/components/personal_data/person_center'], resolve),
      meta: {
        title: '个人中心'
      },
    },
    {
      path: '/listSearch',
      name: 'listSearch',
      component: resolve => require(['@/components/index_children/list_search'], resolve),
      meta: {
        title: '搜索列表'
      }
    },
    {
      path:'/collect',
      name:'collect',
      component: resolve => require(['@/components/product/product_collect.vue'],resolve),
      meta: {
        title: '我的收藏'
      },
    },
    {
      path: '/submitorder',
      name: 'submitorder',
      component: resolve => require(['@/components/product/submit_order'], resolve),
      meta: {
        title: '提交订单'
      },
    },
    {
      path: '/orderdetail',
      name: 'orderdetail',
      component: resolve => require(['@/components/product/order_detail'], resolve),
      meta: {
        title: '订单详情'
      },
    },
    {
      path: '/commoditydetail',
      name: 'commoditydetail',
      component: resolve => require(['@/components/product/commodity_detail'], resolve),
      meta: {
        title: '商品详情'
      },
    },
    {
      path: '/detailsofthebnedition',
      name: 'detailsofthebnedition',
      component: resolve => require(['@/components/product/detailsofthe_bnedition'], resolve),
      meta: {
        title: '商品详情'
      },
      children: [
        {
          path: '',
          name: 'detailCouponNull',
          component: resolve => require(['@/components/product_children/detail_coupon_null'], resolve),
        },
        {
          path: 'detailCoupon',
          name: 'detailCoupon',
          component: resolve => require(['@/components/product_children/detail_coupon'], resolve),
        },
        {
          path: 'detailSku',
          name: 'detailSku',
          component: resolve => require(['@/components/product_children/detail_sku'], resolve),
        }
      ]
    },
    {
      path: '/subordbnedition',
      name: 'subordbnedition',
      component: resolve => require(['@/components/product/subord_bnedition'], resolve),
      meta: {
        title: '提交订单'
      },
      children: [
        {
          path: 'preferenceAcquisition',
          name: 'preferenceAcquisition',
          component: resolve => require(['@/components/product/preference_acquisition'], resolve)
        }
      ]
    },
    {
      path: '/addresslist',
      name: 'addresslist',
      component: resolve => require(['@/components/personal_data/addresslist'], resolve),
      props: true,
      meta: {
        title: '地址列表'
      },
    },
    {
      path: '/editaddress/:id',
      name: 'editaddress',
      component: resolve => require(['@/components/common/editaddress'], resolve),
      props: true,
      meta: {
        title: '编辑地址'
      },
    },
    {
      path: '/customexplain',
      name: 'customexplain',
      component: resolve => require(['@/components/product/custom_explain'], resolve),
      meta: {
        title: '定制说明'
      },
    },
    {
      path: '/paystatus',
      name: 'paystatus',
      component: resolve => require(['@/components/product/pay_status'], resolve),
      meta: {
        title: '支付结果'
      },
    },
    {
      path: '/paystatusinshop',
      name: 'paystatusinshop',
      component: resolve => require(['@/components/product/pay_status_inshop'], resolve),
      meta: {
        title: '支付状态'
      }
    },
    {
      path: '/productlist',
      name: 'productlist',
      component: resolve => require(['@/components/product/product_list'], resolve),
      props: true,
      meta: {
        title: '商品列表'
      }
    },
    {
      path: '/passportlist',
      name: 'passport_list',
      component: resolve => require(['@/components/personal_data/passport_list'], resolve),
      meta: {
        title: '报告列表'
      },
    },
    {
      path: '/passportdetail/:center/:uuid',
      name: 'passportdetail',
      component: resolve => require(['@/components/personal_data/passport_detail'], resolve),
      props: true,
      meta: {
        title: '报告详情'
      }
    },
    {
      path: '/passportdetail',
      name: 'passport_detail',
      component: resolve => require(['@/components/personal_data/passport_detail'], resolve),
      // props: true,
      meta: {
        title: '报告详情'
      },
    },
    {
      path: '/data_validation',
      name: 'data_validation',
      component: resolve => require(['@/components/personal_data/data_validation'], resolve),
      meta: {
        title: '足型数据确认'
      },
    },
    {
      path: '/footcomfir',
      name: 'footcomfir',
      component: resolve => require(['@/components/personal_data/footcomfir'], resolve),
      meta: {
        title: '确认报告'
      },
    },
    {
      path: '/personaldata',
      name: 'personal_data',
      component: resolve => require(['@/components/personal_data/personal_data'], resolve),
      meta: {
        title: '修改资料'
      },
    },
    {
      path: '/coupon/:type',
      name: 'coupon',
      component: resolve => require(['@/components/personal_data/coupon'], resolve),
      props: true,
      meta: {
        title: '优惠劵'
      },
    },
    {
      path: '/orderlist',
      name: 'orderlist',
      component: resolve => require(['@/components/order/orderlist'], resolve),
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/orderdelivery',
      name: 'orderdelivery',
      component: resolve => require(['@/components/order/order_delivery'], resolve),
      meta: {
        title: '订单跟踪'
      }
    },
    {
      path: '/verify',
      name: 'verify',
      component: resolve => require(['@/components/personal_data/verify'], resolve),
      meta: {
        title: '验证手机号'
      },
    },
    {
      path: '/coupondetail',
      name: 'coupon_detail',
      component: resolve => require(['@/components/personal_data/coupon_detail'], resolve),
      props: true,
      meta: {
        title: '优惠劵详情'
      },
    },
    {
      path: '/coupondetailr',
      name: 'coupon_detail_r',
      component: resolve => require(['@/components/personal_data/coupon_detail_r'], resolve),
      props: true,
      meta: {
        title: '优惠券详情'
      },
    },
    {
      path: '/couponReceive',
      name: 'couponReceive',
      component: resolve => require(['@/components/personal_data/coupon_receive'], resolve),
      props: true,
      meta: {
        title: '领取优惠券'
      },
    },
    /*订单*/
    // 订单列表
    // 订单详情
    // 订单评价
    {
      path: '/orderevaluate',
      name: 'orderevaluate',
      component: resolve => require(['@/components/order/order_evaluate'], resolve),
      meta: {
        title: '订单评价'
      },
    },
    /*售后*/
    //售后生成
    {
      path: '/saleservicegenerate',
      name: 'saleservicegenerate',
      component: resolve => require(['@/components/saleservice/saleservice_generate'], resolve),
      meta: {
        title: '售后'
      },
    },
    //售后政策
    {
      path: '/saleservicepolicy',
      name: 'saleservicepolicy',
      component: resolve => require(['@/components/saleservice/saleservice_policy'], resolve),
      meta: {
        title: '售后政策'
      },
    },
    // 售后列表
    {
      path: '/saleservicelist',
      name: 'saleservicelist',
      component: resolve => require(['@/components/saleservice/saleservice_list'], resolve),
      meta: {
        title: '售后列表'
      },
    },
    // 售后详情
    {
      path: '/saleserviceinfo',
      name: 'saleserviceinfo',
      component: resolve => require(['@/components/saleservice/saleservice_info'], resolve),
      meta: {
        title: '售后详情'
      },
    },

    //售后审核成功
    {
      path: '/saleservicesuccess',
      name: 'saleservicesuccess',
      component: resolve => require(['@/components/saleservice/saleservice_success'], resolve),
      meta: {
        title: '售后审核成功'
      },
    },
    // 审核失败
    {
      path: '/saleservicefail',
      name: 'saleservicefail',
      component: resolve => require(['@/components/saleservice/saleservice_fail'], resolve),
      meta: {
        title: '售后审核失败'
      },
    },
    //售后关闭
    {
      path: '/saleserviceclose',
      name: 'saleserviceclose',
      component: resolve => require(['@/components/saleservice/saleservice_close'], resolve),
      meta: {
        title: '售后关闭'
      },
    },

    //物流
    {
      path: '/saleservicelogistics',
      name: 'saleservicelogistics',
      component: resolve => require(['@/components/saleservice/saleservice_logistics'], resolve),
      meta: {
        title: '物流'
      },
    },
    //工厂已收货
    {
      path: '/saleservicereceive',
      name: 'saleservicereceive',
      component: resolve => require(['@/components/saleservice/saleservice_receive'], resolve),
      meta: {
        title: '售后'
      },
    },
    //售后退款
    {
      path: '/saleservicerefund',
      name: 'saleservicerefund',
      component: resolve => require(['@/components/saleservice/saleservice_refund'], resolve),
      meta: {
        title: '售后退款'
      },
    },
    //下拉加载测试
    {
      path: '/list',
      name: 'list',
      component: resolve => require(['@/components/product/list'], resolve),
    },
    //小编推荐
    {
      path: '/article',
      name: 'article',
      component: resolve => require(['@/components/product/article'], resolve),
      meta: {
        title: '小编推荐'
      },
    },
    // 活动专题页
    {
      path: '/activity',
      name: 'activity',
      component: resolve => require(['@/components/product/activity'], resolve),
      meta: {
        title: '活动专题页'
      },
    },
    {
      path: '/getticket',
      name: 'getticket',
      component: resolve => require(['@/components/product/getticket'], resolve),
      meta: {
        title: '券提取页'
      },
    },
    // 失效页面
    {
      path: '/pageFailure',
      name: 'pageFailure',
      component: resolve => require(['@/components/common/page_failure'], resolve)
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  /* const bastoToken = sessionStorage.getItem('bastoToken');
  if(to.name == 'transfer'){
    if(bastoToken && (bastoToken != '' && (bastoToken != null))){
      next(false);
      history.go(-3);
    }else{
      next();
    }
  }else{
    if(bastoToken && (bastoToken != '' && (bastoToken != null))){
      next();
    }else{
      if(window.location.href.indexOf('?membersign=') == -1){
        var transferUrl = encodeURIComponent(location.origin+"/@/transfer");
        var refererUrl = encodeURIComponent(to.fullPath);
        // var refererUrl = encodeURIComponent(location.href);
        //EP小助手的跳转地址  用意礴登录不用修改地址
        // location.href = `http://custom-mall-api-test.epoque.cn/v1/wechat/epoque/entrance?transfer=${transferUrl}&referer=${refererUrl}`;
        // location.href = `http://custom-mall-api-test.epoque.cn/v1/wechat/senda/entrance?transfer=${transferUrl}&referer=${refererUrl}`;
        //生产的跳转地址   用森达登录不用修改地址
        // location.href = `http://custom-mall-api.epoque.cn/v1/wechat/senda/entrance?transfer=${transferUrl}&referer=${refererUrl}`;
        //所有商城统一用epoque授权
        // 这里使用了test=123，调用的是意礴的注册接口，这里仅供测试环境使用，切不能支付
        // location.href = `${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}&test=123`;
        location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}${config.registeraddress}`);

        // 不同的商城用自己的授权
        // location.href = `${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`;
        next(false);
      }else{
        next();
      }
    }
  }*/
  // window.localStorage.removeItem("sendaToken");
  if (to.name == 'transfer') {
    if (localStorage.epoqueToken) {
      next(false)
      history.go(-4);
    } else {
      var referer;
      axios.post('/v1/user/token/get', {
        member_sign: to.query.membersign
      })
        .then(function (res) {
          var token = res.data.token;
          //新获取的token  7天后过期
          const expiredTime = new Date().getTime() + 25200000,
            // const expiredTime = new Date().getTime()+300000,
            epoqueToken = { "content": token, "expiredTime": expiredTime };
          localStorage.setItem("epoqueToken", JSON.stringify(epoqueToken));
          store.state.islogin = res.data.is_new;
          store.state.referer = res.data.referer;
          if (res.data.referer == '') {
            referer = "/"
          } else {
            referer = res.data.referer
          }
          //去掉重定向后的时间戳
          location.replace(location.protocol + '//' + location.host + '/#' + referer);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  } else {
    if (localStorage.epoqueToken) {
      try {
        JSON.parse(localStorage.epoqueToken).content
      } catch (err) {
        window.localStorage.removeItem("epoqueToken");
        location.reload()
      }
      const currentTime = new Date().getTime(),
        epoqueToken = JSON.parse(localStorage.epoqueToken);
      if (epoqueToken.expiredTime - currentTime < 0 && store.state.loginfirst) {
        //删除token
        localStorage.removeItem("epoqueToken");
        //重新获取token
        setTimeout(function () {
          var transferUrl = encodeURI(location.origin + "/@/transfer");
          var refererUrl = encodeURIComponent(to.fullPath);
          window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
        }, 100)
      } else {
        // store.state.loginfirst = false;
        if (store.state.loginfirst) {
          axios.post('/v1/user/update/status').then(function (res) {
            if (res.data.code && res.data.code == 200) {
              store.state.loginfirst = false;
              next()
            } else {
              // location.reload()
              setTimeout(function () {
                var transferUrl = encodeURI(location.origin + "/@/transfer");
                var refererUrl = encodeURIComponent(to.fullPath);
                window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
              }, 100)
            }
          })
        } else {
          next()
        }
      }
    } else {
      if (window.location.href.indexOf('?membersign=') == -1) {
        setTimeout(function () {
          var transferUrl = encodeURI(location.origin + "/@/transfer");
          var refererUrl = encodeURIComponent(to.fullPath);
          // window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
          location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}${config.registeraddress}`);
        }, 100)
      } else {
        next();
      }
    }
  }


})

router.afterEach(route => {
  // 从路由的元信息中获取 title 属性
  if (route.meta.title) {
    document.title = route.meta.title
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      const hackIframe = document.createElement('iframe')
      hackIframe.style.display = 'none'
      document.body.appendChild(hackIframe)
      setTimeout(_ => {
        document.body.removeChild(hackIframe)
      }, 300)
    }
  }
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js